<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body">
          <div class="vx-row no-gutter justify-center items-center">
            <vs-progress
              v-if="loading"
              indeterminate
              color="primary"
            ></vs-progress>
          </div>
          <div>
            <form-wizard
              color="rgba(var(--vs-primary), 1)"
              errorColor="rgba(var(--vs-danger), 1)"
              title="Installation Wizard"
              subtitle="Complete the following steps to install this system"
              finishButtonText="Start System"
            >
              <tab-content
                title="Activation"
                class="mb-5"
                icon="feather icon-shield"
                :before-change="validateStep1"
              >
                <form data-vv-scope="step-1">
                  <div class="vx-row">
                    <div class="ml-4 mr-4 text-center">
                      <p>
                        A valid
                        <router-link :to="`/generate/${machineID}`"
                          >license key</router-link
                        >
                        from our organization is required to start this system.
                        Your installation ID is listed below. Please contact our
                        support team <b>+254 710 710 037</b> with the
                        <b>Installation ID</b> below to aquire a new license key
                        then copy and paste below.
                      </p>

                      <div class="flex justify-center items-center">
                        <div>
                          <b class="mt-2"><small>ID: </small></b
                          ><code
                            ><small>{{ machineID }}</small></code
                          >
                        </div>
                        <vs-button
                          v-clipboard:copy="machineID"
                          v-clipboard:success="copy"
                          v-clipboard:error="error"
                          class="ml-2"
                          radius
                          color="primary"
                          type="border"
                          icon-pack="feather"
                          icon="icon-copy"
                        ></vs-button>
                      </div>
                    </div>
                    <div v-show="false" class="vx-col md:w-1/2 w-full">
                      <vs-textarea
                        disabled="true"
                        v-model="machineID"
                        label="Installation ID"
                        class="md:mt-2 mt-2 mb-0"
                        rows="3"
                        name="installation_id"
                        v-validate="'required|min:20'"
                      />
                    </div>
                    <span class="text-danger">{{
                      errors.first("step-1.installation_id")
                    }}</span>
                    <div class="vx-col md:w-full w-full">
                      <vs-textarea
                        v-model="license"
                        label="License Key"
                        class="md:mt-2 mt-2 mb-0"
                        rows="3"
                        name="license"
                        v-validate="'min:162'"
                      />
                      <!-- TODO: Disabled license verification until update from sso server is complete -->
                      <span class="text-danger">{{
                        errors.first("step-1.license")
                      }}</span>
                    </div>
                  </div>
                </form>
              </tab-content>

              <tab-content
                title="Database"
                class="mb-5"
                icon="feather icon-database"
                :before-change="validateDB"
              >
                <form data-vv-scope="step-db">
                  <div class="vx-row">
                    <div class="vx-col w-full ml-4">
                      <span class="text-sm"
                        >We keep secure cloud periodic backups of your data
                        encrypted at our database servers</span
                      >
                    </div>
                    <div v-if="allow_backups" class="vx-row w-full ml-4 mr-4">
                      <!-- <vs-divider>Database</vs-divider> -->
                      <div class="vx-col w-full mt-5">
                        <v-select
                          class="inputx w-full"
                          name="database"
                          placeholder="Select database option"
                          :value="dbOptions[0].label"
                          v-model="create_db"
                          :options="dbOptions"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          v-validate="'required'"
                        />
                        <span class="text-sm">
                          You have two options to create a new database or link
                          with existing database</span
                        >
                        <br />
                        <span class="text-danger">{{
                          errors.first("step-1.database")
                        }}</span>
                      </div>
                      <div
                        v-if="create_db && !create_db.value"
                        class="vx-col w-full mt-5"
                      >
                        <vs-input
                          label="Database ID"
                          v-model="link_db"
                          class="w-full"
                          name="remote_db"
                          v-validate="'required'"
                        />
                        <span class="text-sm">
                          Enter external installation id to link this database
                          with the external database</span
                        >
                        <br />
                        <span class="text-danger">{{
                          errors.first("step-1.remote_db")
                        }}</span>
                      </div>
                      <div class="vx-col md:w-1/3 w-full mt-5">
                        <small class="ml-2">Protocol</small>
                        <v-select
                          class="inputx w-full"
                          name="protocol"
                          v-model="protocol"
                          :options="protocolOptions"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          v-validate="'required'"
                        />
                      </div>
                      <div class="vx-col md:w-1/3 w-full mt-5">
                        <vs-input
                          v-on:keyup.alt.67="overide"
                          label="Remote DB Url"
                          v-model="remote_url"
                          class="w-full"
                          name="remote_url"
                          v-validate="{ required: true }"
                        />
                        <span class="text-danger">{{
                          errors.first("step-1.remote_url")
                        }}</span>
                      </div>
                      <div class="vx-col md:w-1/3 w-full mt-5">
                        <vs-input
                          label="Remote DB Port"
                          v-model="remote_port"
                          class="w-full"
                          name="remote_port"
                          v-validate="'numeric'"
                        />
                        <span class="text-danger">{{
                          errors.first("step-1.remote_port")
                        }}</span>
                      </div>
                      <div v-if="false" class="vx-col md:w-1/2 w-full mt-5">
                        <vs-input
                          label="Remote DB Username"
                          v-model="remote_username"
                          class="w-full"
                          name="remote_username"
                          v-validate="'alpha'"
                        />
                        <span class="text-danger">{{
                          errors.first("step-1.remote_username")
                        }}</span>
                      </div>
                      <div v-if="false" class="vx-col md:w-1/2 w-full mt-5">
                        <vs-input
                          type="password"
                          label="Remote DB Password"
                          v-model="remote_password"
                          class="w-full"
                          name="remote_password"
                        />
                        <span class="text-danger">{{
                          errors.first("step-1.remote_password")
                        }}</span>
                      </div>
                    </div>
                  </div>
                </form>
              </tab-content>

              <!-- tab 2 content -->
              <tab-content
                title="Localization"
                class="mb-5"
                icon="feather icon-globe"
                :before-change="validateStep2"
              >
                <form data-vv-scope="step-2">
                  <div class="vx-row">
                    <!-- <div class="vx-col md:w-1/2 w-full mt-5">
                      <vs-input
                        label="Business Name"
                        v-model="business_name"
                        class="w-full"
                        name="business_name"
                        v-validate="'required'"
                      />
                      <span class="text-danger">{{
                        errors.first("step-2.business_name")
                      }}</span>
                    </div>
                    <div class="vx-col md:w-1/2 w-full mt-5">
                      <vs-input
                        label="Main Phone"
                        v-model="main_phone"
                        class="w-full"
                        name="main_phone"
                        v-validate="'required|numeric|max:10|min:10'"
                      />
                      <span class="text-danger">{{
                        errors.first("step-2.main_phone")
                      }}</span>
                    </div>
                    <div class="vx-col md:w-1/2 w-full mt-5">
                      <vs-input
                        label="Postal Address"
                        v-model="postal_address"
                        class="w-full"
                        name="address"
                        v-validate="'required'"
                      />
                      <span class="text-danger">{{
                        errors.first("step-2.address")
                      }}</span>
                    </div>
                    <div class="vx-col md:w-1/2 w-full mt-5">
                      <vs-input
                        label="Postal City"
                        v-model="postal_city"
                        class="w-full"
                        name="city"
                        v-validate="'required'"
                      />
                      <span class="text-danger">{{
                        errors.first("step-2.city")
                      }}</span>
                    </div> -->
                    <div class="vx-col md:w-1/2 w-full mt-5">
                      <small class="ml-2">Country</small>
                      <v-select
                        v-if="countryOptions.length > 0"
                        @input="updateCurrency"
                        class="inputx w-full"
                        name="country"
                        label="countryName"
                        placeholder="Select Country"
                        v-model="country"
                        :options="countryOptions"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-validate="'required'"
                      />
                      <span v-else class="text-danger"
                        >No Country is Available</span
                      >
                      <span class="text-danger">{{
                        errors.first("step-2.county")
                      }}</span>
                    </div>
                    <div class="vx-col md:w-1/2 w-full mt-5">
                      <vs-input
                        v-if="countryOptions.length > 0"
                        label="Currency"
                        disabled="true"
                        v-model="currency"
                        class="w-full"
                        name="currency"
                        v-validate="'required'"
                      />
                      <span class="text-danger">{{
                        errors.first("step-2.currency")
                      }}</span>
                    </div>
                    <div v-show="false">
                      <vs-divider>Tax</vs-divider>
                      <div class="vx-col md:w-1/2 w-full">
                        <vs-input
                          label="Tax PIN"
                          v-model="tax_pin"
                          class="w-full"
                          name="pin"
                        />
                      </div>
                      <div class="vx-col md:w-1/2 w-full">
                        <vs-input
                          label="VAT Reg"
                          v-model="vat_reg"
                          class="w-full"
                          name="vat_reg"
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </tab-content>

              <!-- tab 3 content -->
              <tab-content
                title="Admin"
                class="mb-5"
                icon="feather icon-user"
                :before-change="validateStep3"
              >
                <form data-vv-scope="step-3">
                  <div class="vx-row" v-if="!admin_available">
                    <div v-if="admin_available" class="vx-col w-full mt-5">
                      <vs-button class="flex flex-wrap mr-4 center"
                        >Skip Admin Registration</vs-button
                      >
                    </div>
                    <div class="vx-col md:w-1/2 w-full mt-5">
                      <vs-input
                        label="Name"
                        v-model="name"
                        class="w-full"
                        name="name"
                        v-validate="'required|min:4'"
                      />
                      <span class="text-danger">{{
                        errors.first("step-3.name")
                      }}</span>
                    </div>

                    <div class="vx-col md:w-1/2 w-full mt-5">
                      <vs-input
                        label="Phone"
                        v-model="phone"
                        class="w-full"
                        name="phone"
                        v-validate="'required|numeric|max:10|min:10'"
                      />
                      <span class="text-danger">{{
                        errors.first("step-3.phone")
                      }}</span>
                    </div>

                    <vs-divider>Other</vs-divider>
                    <div class="vx-col md:w-1/2 w-full">
                      <vs-input
                        label="Username"
                        v-model="username"
                        class="w-full"
                        name="username"
                        v-validate="'required|alpha|min:3'"
                      />
                      <span class="text-danger">{{
                        errors.first("step-3.username")
                      }}</span>
                    </div>

                    <div class="vx-col md:w-1/2 w-full">
                      <vs-input
                        label="Email"
                        v-model="email"
                        class="w-full"
                        name="email"
                        v-validate="'email'"
                      />
                      <span class="text-danger">{{
                        errors.first("step-3.email")
                      }}</span>
                    </div>

                    <div class="vx-col md:w-1/2 w-full mt-5">
                      <vs-input
                        type="password"
                        label="Password"
                        v-model="password"
                        class="w-full"
                        name="password"
                        ref="password"
                        v-validate="'required|min:4'"
                      />
                      <span class="text-danger">{{
                        errors.first("step-3.password")
                      }}</span>
                    </div>

                    <div class="vx-col md:w-1/2 w-full mt-5">
                      <vs-input
                        type="password"
                        label="Confirm Password"
                        v-model="confirm_password"
                        class="w-full"
                        name="confirm_password"
                        v-validate="'required|confirmed:password'"
                      />
                      <span class="text-danger">{{
                        errors.first("step-3.confirm_password")
                      }}</span>
                    </div>
                  </div>
                  <div class="vx-col text-center center-div p-4" v-else>
                    <feather-icon
                      icon="CheckIcon"
                      class="text-success center p-3 inline-flex rounded-full"
                    >
                    </feather-icon>
                    <p>
                      An admin user is already registered. Please contact an
                      admin to register other accounts on this system. Continue
                      with the installation below.
                    </p>
                  </div>
                </form>
              </tab-content>

              <!-- tab 4 content -->
              <tab-content
                title="Finish"
                class="mb-5"
                icon="feather icon-arrow-right"
                :before-change="validateStep4"
              >
                <form data-vv-scope="step-4">
                  <div class="vx-col text-center center-div p-4">
                    <feather-icon
                      icon="CheckIcon"
                      class="text-success center p-3 inline-flex rounded-full"
                    >
                    </feather-icon>
                    <p>
                      Its been a blast! <br />This installation has been
                      successfully finished and license activated, Click finish
                      below to continue.
                    </p>
                  </div>
                </form>
              </tab-content>
            </form-wizard>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import vSelect from "vue-select";

import crypto from "crypto";
import { v4 as uuidv4 } from "uuid";

import countries from "./countries.json";

import { Validator } from "vee-validate";
const dict = {
  custom: {
    business_name: {
      required: "A business name is required",
    },
    main_phone: {
      required: "A phone number is required",
      numeric: "Phone numbers may only be numeric",
      max: "A valid 10 digit phone number is required",
      min: "A valid 10 digit phone number is required",
    },
    address: {
      required: "A postal address is required",
    },
    city: {
      required: "A valid postal city is required",
    },
    country: {
      required: "Select a country",
    },
    currency: {
      required: "A valid currency code is required",
    },
    license: {
      required: "A valid license key is required to activate this program",
      min: "The license key should be at least 162 characters long",
    },
    name: {
      required: "A valid name is required",
    },
    phone: {
      required: "A phone number is required",
      numeric: "Phone numbers may only be numeric",
      max: "A valid 10 digit phone number is required",
      min: "A valid 10 digit phone number is required",
    },
    username: {
      required: "A valid username is required",
      alpha: "Usernames should only contain alphabetic characters",
      min: "Usernames should be at least 3 characters",
    },
    email: {
      email: "A valid email is expected",
    },
    password: {
      required: "A password is required",
      min: "Passwords should be at least 4 characters",
    },
    confirm_password: {
      required: "Confirm your password",
      confirmed: "Passwords do not match",
    },
    branch_name: {
      required: "The default branch is required",
    },
    branch_phone: {
      required: "The Branch phone number is required",
      numeric: "Phone numbers may only be numeric",
      max: "A valid 10 digit phone number is required",
      min: "A valid 10 digit phone number is required",
    },
    payment_option: {
      required: "The default payment option is required",
    },
  },
};

import idb from "@/db/idb";
import FeatherIcon from "../../../../components/FeatherIcon.vue";
import p from "@/http/pouch/index.js";
import PouchDB from "pouchdb-browser";

Validator.localize("en", dict);

export default {
  components: {
    FormWizard,
    TabContent,
    FeatherIcon,
    vSelect,
  },
  data() {
    return {
      loading: false,
      machineID: "Getting Installation ID ... ",
      license: "",
      requireLicense: false,
      //start
      business_name: "",
      main_phone: "",
      postal_address: "",
      postal_city: "",
      country: null,
      c: "",
      tax_pin: "",
      vat_reg: "",
      // admin
      admin_available: false,
      admin: {},
      username: "",
      password: "",
      confirm_password: "",
      name: "",
      email: "",
      phone: "",
      // other
      branch_name: "",
      branch_phone: "",
      payment_option: "",
      payment_option2: "",
      countryOptions: countries,
      publicKey: "",
      //
      allow_backups: true,
      create_db: null,
      link_db: "",
      dbOptions: [
        {
          label: "Create new database",
          value: true,
        },
        {
          label: "Link existing database",
          value: false,
        },
      ],
      protocol: "https",
      protocolOptions: ["https", "http"],
      remote_url: "db.vue.co.ke",
      remote_port: 6984,
      remote_username: process.env.VUE_APP_DB_USERNAME,
      remote_password: process.env.VUE_APP_DB_PASSWORD,
      overide_credentials: false,
    };
  },
  watch: {
    protocol(v) {
      switch (this.protocol) {
        case "https":
          this.remote_port = 6984;
          break;

        default:
          this.remote_port = 5984;
          break;
      }
    },
  },
  pouch: {
    branchData() {
      // useless, to be removed
      return {
        database: process.env.VUE_APP_DB,
        selector: { type: "branch" },
        sort: [
          {
            name: "asc",
          },
        ],
      };
    },
    POData() {
      // useless, to be removed
      return {
        database: process.env.VUE_APP_DB,
        selector: { type: "PO" },
        sort: [
          {
            name: "asc",
          },
        ],
      };
    },
  },
  computed: {
    branch() {
      var b = this.branchData ? this.branchData : [];
      return b.length > 0;
    },
    payment() {
      var p = this.POData ? this.POData : [];
      return p.length > 0;
    },
    currency: {
      get() {
        return this.c;
      },
      set(d) {
        this.c = d;
      },
    },
    getDB() {
      return `${this.protocol}://${this.remote_username}:${this.remote_password}@${this.remote_url}:${this.remote_port}`;
    },
  },
  methods: {
    copy() {
      this.$vs.notify({
        title: "Success",
        text: "Machine ID successfully copied to clipboard",
        color: "success",
        iconPack: "feather",
        position: "top-center",
        icon: "icon-check-circle",
      });
    },
    error() {
      this.$vs.notify({
        title: "Error",
        text: "Failed to copy to clipboard",
        color: "danger",
        iconPack: "feather",
        position: "top-center",
        icon: "icon-alert-circle",
      });
    },
    overide() {
      // TODO: Implement an overide
      this.overide_credentials = !this.overide_credentials;
    },
    updateCurrency() {
      this.currency = this.country.currencyCode;
    },
    getData(key) {
      if (window.require) {
      }
    },
    async getMachineID() {
      var k = await idb.getRecord("installationID");
      if (k) {
        this.machineID = k.data;
      } else {
        var uuid = uuidv4();
        idb.saveRecord({
          type: "installationID",
          data: uuid,
        });
        this.machineID = uuid;
      }
    },
    //
    decrypt(a) {
      try {
        let key = Buffer.from(a[0], "hex");
        let iv = Buffer.from(a[1], "hex");
        let en = Buffer.from(a[2], "hex");
        let decipher = crypto.createDecipheriv(
          "aes-256-cbc",
          Buffer.from(key),
          iv
        );
        let de = decipher.update(en);
        de = Buffer.concat([de, decipher.final()]);
        return JSON.parse(atob(de.toString()));
      } catch (err) {
        return false;
      }
    },
    verify(d) {
      try {
        const verify = crypto.createVerify("RSA-SHA256");
        verify.update(new Buffer(JSON.stringify(d.data)));
        return verify.verify(this.publicKey, d.signature, "hex");
      } catch (e) {
        console.log("Signature verification error", e);
        return false;
      }
    },
    async syncDB() {
      if (this.allow_backups) {
        let db = this.getDB;
        if (this.create_db.value) {
          db = `${db}/db-erp-${this.machineID}`;
        } else {
          db = `${db}/${this.link_db}`;
        }
        await idb.saveRecord({
          type: "database",
          db: db,
          allow_backups: this.allow_backups,
          create_db: this.create_db.value,
          link_db: this.link_db,
          remote_url: this.remote_url,
          remote_username: this.remote_username,
          remote_password: this.remote_password,
        });
        p.init(this.$pouch);
        this.$vs.notify({
          position: "bottom-center",
          color: "warning",
          title: `Database Sync Started`,
          text:
            "I'll try and contact the database and sync data whenever possible",
        });
      } else {
        await idb.saveRecord({
          type: "database",
          db: null,
          allow_backups: this.allow_backups,
        });
      }
    },
    showError(message) {
      this.$vs.notify({
        title: "Error",
        text: message,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        time: 13000,
      });
    },
    validateDB() {
      return new Promise(async (resolve, reject) => {
        try {
          if (!(this.create_db instanceof Object))
            throw new Error("Select database option");
          if (this.allow_backups) {
            let db = this.getDB;
            if (this.create_db.value) {
              db = `${db}/db-erp-${this.machineID}`;
              var pdb = new PouchDB(db);
            } else {
              db = `${db}/${this.link_db}`;
              var pdb = new PouchDB(db, { skip_setup: true });
            }
            var c_pdb = await pdb.info();
          } else {
            var c_pdb = true;
          }
          if (c_pdb.purge_seq !== undefined) {
            this.$validator.validateAll("step-1").then(async (result) => {
              this.loading = false;
              if (result) {
                await this.syncDB();
                return resolve(true);
              }
              return reject(c_pdb);
            });
          } else {
            this.showError(
              `Failed to connect to database. ${c_pdb.reason ||
                "Unknown Error"}`
            );
            return reject(c_pdb.reason);
          }
        } catch (e) {
          this.showError(`Failed to connect to database. ${e.reason || e}`);
          return reject(e);
        }
      });
    },
    validateStep1() {
      if (this.requireLicense) {
        var a = this.license.split(":");
        this.loading = true;
        return new Promise(async (resolve, reject) => {
          if (a.length != 3) {
            this.loading = false;
            this.showError(
              "Invalid License Key Provided. License keys should match our signature. Please contact our Support Team."
            );
            reject("ERROR");
          } else {
            try {
              this.$validator.validateAll("step-1").then(async (result) => {
                this.loading = false;
                if (result) {
                  var c = false;
                  var d = this.decrypt(a);
                  if (d != false) {
                    var chs = this.verify(d);
                    if (chs) {
                      var data = d.data;
                      if (data.machineID === this.machineID) {
                        await idb.saveRecord({
                          type: "license",
                          installationID: data.machineID,
                          license: this.license,
                          expiry: data.expiry,
                          start: data.start,
                          date: Date.now(),
                          required: this.requireLicense,
                        });

                        this.business_name =
                          d.data.metadata.business_name || "";
                        this.main_phone = d.data.metadata.main_phone || "";
                        this.postal_address =
                          d.data.metadata.postal_address || "";
                        this.postal_city = d.data.metadata.postal_city || "";
                        this.country = d.data.metadata.country || "";
                        this.currency = d.data.metadata.currency || "";

                        this.$vs.notify({
                          title: "Cheers",
                          text: `Thank you for choosing Vue Analytics. Your license key has been successfully verified 
                          and will expire on ${this.$moment(data.expiry).format(
                            "dddd, MMMM Do YYYY"
                          )}`,
                          iconPack: "feather",
                          icon: "icon-check-circle",
                          color: "success",
                          time: 13000,
                        });
                        resolve(true);
                      } else {
                        this.showError(
                          "This license belongs to another PC. Request one for your PC."
                        );
                        reject("ERROR");
                      }
                    } else {
                      this.showError("License contains an invalid signature");
                      reject("ERROR");
                    }
                  } else {
                    this.showError("Invalid License Provided");
                    reject("ERROR");
                  }
                } else {
                  this.showError("There is an error in your form");
                  reject("correct all values");
                }
              });
            } catch (e) {
              this.showError(
                `Failed to connect to database. ERROR: ${e.reason || e}`
              );
              reject(e);
            }
          }
        });
      }
      return new Promise(async (resolve, reject) => {
        this.$vs.notify({
          title: "License Verification Disabled",
          text: `Skipping license verification`,
          iconPack: "feather",
          icon: "icon-check-circle",
          color: "success",
          time: 13000,
        });
        await idb
          .saveRecord({
            type: "license",
            installationID: this.machineID,
            license: this.license,
            expiry: Date.now(),
            start: Date.now(),
            date: Date.now(),
            required: this.requireLicense,
          })
          .then(() => {
            resolve(true);
          });
      });
    },
    validateStep2() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-2").then(async (result) => {
          this.loading = false;
          if (result) {
            await idb.saveRecord({
              type: "business",
              business_name: this.business_name,
              main_phone: this.main_phone,
              postal_address: this.postal_address,
              postal_city: this.postal_city,
              country: this.country.countryName,
              currency: this.currency,
              vat_reg: this.vat_reg,
              tax_pin: this.tax_pin,
            });
            this.$pouch
              .find(
                {
                  selector: {
                    z: 0,
                  },
                },
                process.env.VUE_APP_DB
              )
              .then((res) => {
                this.admin_available = res.docs.length > 0 || false;
                if (res.docs.length > 0) {
                  this.admin = res.docs[0];
                  this.$vs.notify({
                    title: "Opps :)",
                    text:
                      "There is an Admin user already registered in this system",
                    iconPack: "feather",
                    icon: "icon-check-circle",
                    color: "warning",
                  });
                }
              })
              .catch((err) => {
                this.showError(err);
              });
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    validateStep3() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-3").then((result) => {
          this.loading = false;
          if (result) {
            if (!this.admin_available) {
              const obj = {
                f: this.username.toLowerCase(),
                c: this.password,
                b: this.name,
                a: this.email,
                d: this.phone,
                e: "admin",
                g: Date.now(),
                z: 0,
              };

              this.$store
                .dispatch("users/addUser", obj)
                .then((r) => {
                  this.$vs.notify({
                    color: "success",
                    title: "User Registered Successfully",
                    text: "You have successfully registered a user",
                  });
                  resolve(true);
                  this.admin_available = true;
                  this.admin = r;
                })
                .catch((err) => {
                  console.error(err);
                  this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    text: err,
                  });
                });
            } else {
              resolve(true);
            }
          } else {
            reject("correct all values");
          }
        });
      });
    },
    validateStep4() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-4").then((result) => {
          this.finish();
        });
      });
    },
    async finish() {
      this.$vs.notify({
        position: "bottom-center",
        color: "primary",
        title: `Processing`,
        text:
          "Activating your installation. Please wait. It only takes some seconds",
        time: 15000,
      });
      await idb.saveRecord({
        type: "installation",
        complete: true,
      });

      var l = await this.getRecord("license");

      await idb.saveRecord({
        type: "activation",
        active: true,
        license: this.license,
        required: this.requireLicense,
        start: new Date(l.start).setHours(0, 0, 0, 0),
        expiry: l.expiry,
        date: new Date(Date.now()),
      });
      this.$router.push({
        name: "login",
      });
      this.$vs.notify({
        position: "bottom-center",
        color: "success",
        title: `Thank You`,
        text:
          "System successfully activated. You may now login and use this system.",
      });
    },
    savePaymentOption(o) {
      this.$store
        .dispatch("payment_options/addOption", o)
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: `${o.payment_option} Added Successfully`,
            text: "You have successfully added a new payment option",
          });
        })
        .catch((err) => {
          console.error(err);
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: err,
          });
        });
    },
    async getRecord(type) {
      return await idb.getRecord(type);
    },
    async fill(a, t) {
      let d = (await this.getRecord(t)) || null;
      if (d) {
        for (let i = 0; i < a.length; i++) {
          const e = a[i];
          if (this.hasOwnProperty(e) && d.hasOwnProperty(e)) {
            this[`${e}`] = d[e];
          }
        }
        return d;
      }
      return false;
    },
  },
  async created() {
    let i = await this.getRecord("installation");
    if (i && !i.complete) {
      this.$vs.notify({
        title: "Continue where you left off",
        text:
          "This installation had already started, we saved some data for you so you can continue where you left off.",
        iconPack: "feather",
        icon: "icon-check-circle",
        color: "success",
        time: 13000,
      });
    } else {
      await idb.saveRecord({
        type: "installation",
        complete: false,
      });
    }
    await this.fill(["license"], "license");
    await this.fill(
      [
        "create_db",
        "link_db",
        "remote_url",
        "remote_username",
        "allow_backups",
      ],
      "database"
    );
    this.create_db = this.dbOptions.find((e) => e.value === this.create_db);
    await this.fill(["branch_name", "branch_phone"], "branch");
    await this.fill(["payment_option", "payment_option2"], "payment");
    let f = await this.fill(
      [
        "business_name",
        "main_phone",
        "postal_address",
        "postal_city",
        "tax_pin",
        "vat_reg",
        "country",
        "currency",
      ],
      "business"
    );
    if (f) {
      this.currency = f.currency;
      // this.updateCurrency();
      // this.country = this.country.countryName;
    }
    this.publicKey =
      "-----BEGIN PUBLIC KEY-----\n" +
      "MIGeMA0GCSqGSIb3DQEBAQUAA4GMADCBiAKBgGC7ihHUgBC5NdYRF/xxGKGdhn2W\n" +
      "2IXRhaKYZEJvr1s6t+tQMN9yYvhr4j3eZk1zJlMgXOXFr0mOncA3UnLVNQPwsitK\n" +
      "bjh2yWA99lNiW3fAWhlanX2RJPbVP/wuueI5URZXXaxkpH/b/RSswXvjpof+kjED\n" +
      "YRf6+GxCrzJyof/1AgMBAAE=\n" +
      "-----END PUBLIC KEY-----";
    this.getMachineID();
  },
};
</script>

<style lang="scss">
.center-div {
  position: relative;
  width: 100%;
  height: 100%;
}

.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
